import router from './router';
import socket from './socket';
import login from './login';
import core from './core';
import modals from './modals';
import users from './users';
import projects from './projects';
import projectManagers from './project-managers';
import boards from './boards';
import boardMemberships from './board-memberships';
import labels from './labels';
import lists from './lists';
import cards from './cards';
import tasks from './tasks';
import attachments from './attachments';
import activities from './activities';
import commentActivities from './comment-activities';
import notifications from './notifications';
import pointSystems from './point-systems';
import monthlyReport from './monthly-report';
import employeePlans from './employee-plans';
import contentViewPlans from './content-view-plans';
import dampingCoefficients from './damping-coefficients';
import contentCardDefaults from './content-card-defaults';
import cardPointData from './card-point-data';
import cardPointAdvancedData from './card-point-advanced-data';
import listReportData from './list-report-data';

export default {
  ...router,
  ...socket,
  ...login,
  ...core,
  ...modals,
  ...users,
  ...projects,
  ...projectManagers,
  ...boards,
  ...boardMemberships,
  ...labels,
  ...lists,
  ...cards,
  ...tasks,
  ...attachments,
  ...activities,
  ...commentActivities,
  ...notifications,
  ...pointSystems,
  ...monthlyReport,
  ...employeePlans,
  ...contentViewPlans,
  ...dampingCoefficients,
  ...contentCardDefaults,
  ...cardPointData,
  ...cardPointAdvancedData,
  ...listReportData,
};
